import React from 'react';
import { toast } from 'react-hot-toast';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Show a Material UI styled toast.
 * @param {Object} data - Toast data.
 * @param {string} data.type - MUI alert type ('success', 'info', 'warning', 'error').
 * @param {string} data.title - Title text.
 * @param {string} data.message - Message text.
 */
const backgroundColors = {
    success: '#F1FBF4',   // light green
    warning: '#FFFCF0',   // light yellow
    info: '#F8F7FF',   // light purple
    error: '#FFF6F3',   // light red
};

const iconColors = {
    success: '#189057',   // dark green
    warning: '#BF670F',   // orange-brown
    info: '#6270F3',   // indigo
    error: '#FA1320',   // red
};

const borderColor = {
    success: '1px solid #92DCAE',   // dark green
    warning: '1px solid #FFC400',   // orange-brown
    info: '1px solid #CBC6FC',   // indigo
    error: '1px solid #FFBDAD',   // red
};
const allowTimer = ({ message }) => {
    if (message === "Please select at least one filter before searching.") {
        return true;
    }
    else {
        return false;
    }
}
export const showAlertToast = ({ type = 'info', title = '', message = '' } = {}) => {
    toast.custom((t) => (
        <div
            style={{
                position: 'relative',
                width: '400px',
                zIndex: 999999, // Increased z-index
                marginTop: '10px',
                opacity: t.visible ? 1 : 0,
                transition: 'all 0.3s ease-in-out',
            }}
        >
            <Alert
                severity={type}
                sx={{
                    borderRadius: '10px',
                    position: 'relative',
                    paddingRight: '30px', // space for close icon
                    backgroundColor: backgroundColors[type] || 'white',
                    border: borderColor[type] || 'white',
                    '& .MuiAlert-icon': {
                        color: iconColors[type] || 'inherit',
                        fontSize: '20px',
                        marginTop: '10px'
                    },
                }}
                action={
                    <IconButton
                        aria-label="close"
                        onClick={() => toast.dismiss(t.id)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'inherit',
                        }}
                    >
                        <CloseIcon
                            style={
                                {
                                    fontSize: '16px'
                                }
                            }
                        />
                    </IconButton>
                }
            >
                {title &&
                    <AlertTitle>
                        <span style={{ fontWeight: 500, color: '#252C34', fontSize: '14px' }}>
                            {title}
                        </span>
                    </AlertTitle>
                }
                <span style={
                    {
                        color: '#384553',
                        fontWeight: 400,
                        fontSize: '12px'
                    }
                }>
                    {message}
                </span>
            </Alert>
        </div>
    ), {
        duration: ((type === 'error' || type === 'warning') && (allowTimer({ message: message })) === false) ? Infinity : 2000
    });
};
